<template>
  <div class="knowledge-case-list-body">
    <p>场景知识云为您找到相关结果约 {{ page.total }} 个</p>
    <div v-if="list&&list.length">
      <div
        class="knowledge-scenes-list"
        v-for="(item, index) in list"
        :key="index"
        @click="view(item)"
      >
        <span class="knowledge-case-title" v-html="item.projectNameLight"></span>
        <p>
          <span v-for="(tag,ti) in item.tagNames" :key="ti">{{ tag }}</span>
        </p>
        <div>
          <span>采购地区：{{ item.locationName }}</span>
          <span>成交时间：{{ item.winPublishTime }}</span>
          <span>采购金额：￥{{ item.bidWinningAmount }}</span>
          <span>采购业主：{{ item.purUnitName }}</span>
        </div>
<!--        <div>-->
<!--          <span>{{ item.projectDesc }}</span>-->
<!--        </div>-->
      </div>
      <div class="pagination-body">
        <a-pagination
          :total="page.total"
          :current="page.current"
          show-quick-jumper
          :show-total="(total) => `共 ${total} 项`"
          @change="pageChange"
        />
      </div>
    </div>
    <div v-else style="padding-top: 50px">
      <a-empty />
    </div>
  </div>
</template>

<script>
import { getProjectList, getJfhDicts } from "@/api/jfh";
import moment from "moment";

export default {
  props: ["search"],
  data() {
    return {
      list: [],
      searchVal: "",
      page: {
        total: 0,
        current: 1,
        size: 10
      }
    };
  },
  watch: {
    search: function(val) {
      this.searchVal = val;
      this.loadData();
    }
  },
  mounted() {
    this.searchVal = this.search;
    setTimeout(() => {
      this.loadData();
    }, 100);
  },
  methods: {
    loadData() {
      let search = this.searchVal;
      getProjectList(this.page, search).then((res) => {
        const list = res.data.dataList;
        this.page.total = res.data.totalCount;
        const dictCode = [
          ...list.map(e => e.location),
          ...list.map(e => e.ownedItem),
          ...list.map(e => e.categories)
        ];
        getJfhDicts(dictCode).then(res2 => {
          const dicts = res2.data;
          this.list = list.map(e => {
            const locs = dicts.filter(l => l.thirdLevelCode === e.location);
            const loc = locs && locs.length && locs[0] || {};
            const locationName = `${loc.firstLevelName} - ${loc.secondLevelName}`;
            const tagCodes = [
              ...e.ownedItem,...e.categories
            ]
            const tagNames = dicts.filter(l => tagCodes.indexOf(l.thirdLevelCode) !== -1).map(l=>l.thirdLevelName)
            return {
              projectId: e.projectId, // 编号
              projectName: e.projectName,//项目名
              projectNameLight: e.projectNameLight,//项目名高亮
              location: e.location,//服务地区code
              locationName,//服务地区
              bidPublishTime: moment(e.bidPublishTime).format("YYYY-MM-DD"),//招标发布时间
              winPublishTime: moment(e.winPublishTime).format("YYYY-MM-DD"),//中标/废标发布时间
              bidSource: e.bidSource,//案例来源
              purUnitName: e.purUnitName,//预算单位名称
              purUnitAddress: e.purUnitAddress,//采购单位地址
              purAgencyName: e.purAgencyName,//代理机构名称
              agencyAddress: e.agencyAddress,//代理机构地址
              categories: e.categories,//分类标签
              budgetAmount: e.budgetAmount,//预算
              bidWinningAmount: e.bidWinningAmount,//成交总额
              projectDesc: e.projectDesc,//项目概况
              ownedItem: e.ownedItem,//所属品目
              tagCodes,
              tagNames,
            };
          });
        });
      });
    },
    pageChange(e) {
      this.page.current = e;
      this.loadData();
    },
    view(info) {
      this.$router.push({
        name: "homeKnowledgeCaseInfo",
        params: info
      });
    }
  }
};
</script>

<style lang="less" scoped>
.knowledge-case-list-body {
  > p {
    font-size: 12px;
    color: #8c8c8c;
    line-height: 12px;
    margin-bottom: 24px;
  }

  > div {
    background: #fff;
    padding: 0 24px 24px;

    .knowledge-scenes-list {
      padding: 24px 0;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;

      > span {
        display: block;
        font-size: 16px;
        margin-bottom: 20px;
        line-height: 16px;
      }

      > p {
        display: flex;

        > span {
          height: 22px;
          background: #fafafa;
          border: 1px solid #d9d9d9;
          border-radius: 2px;
          margin-right: 8px;
          padding: 0 10px;
          color: #262626;
          font-size: 12px;
          line-height: 20px;
        }
      }

      > div {
        display: flex;
        align-items: center;
        margin-top: 16px;

        > span {
          margin-right: 40px;
          font-size: 12px;
          color: #8c8c8c;
          line-height: 12px;
        }
      }
    }
  }
}
</style>
<style lang="less">
.knowledge-case-title {
  em {
    color: #1ABC9C;
    font-style: inherit;
  }
}
</style>
